export default __webpack_public_path__ + "static/media/roopkund.8da9877b.jpg";